export default "/images/vendor/flag-icon-css/flags/4x3/re.svg?f05b5f1673afe6db0760a5fc7e8610c6";